<template>
  <v-app>
    <!-- Sidebar Navigation - Hidden in form detail views -->
    <Sidebar v-if="!isFormDetailView" v-model="drawer" v-model:rail="rail" />

    <!-- Top Navigation Bar -->
    <TopNav
      :rail="rail"
      :is-form-view="isFormDetailView"
      @toggle-drawer="drawer = !drawer"
      @toggle-rail="rail = !rail"
    />

    <!-- Main Content Area -->
    <v-main class="main-content" :class="{ 'main-content--fullwidth': isFormDetailView }">
      <v-container fluid :class="isFormDetailView ? 'pa-0' : 'pa-6'">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue'
import TopNav from '@/components/layout/TopNav.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Dash',
  components: {
    Sidebar,
    TopNav,
  },
  data() {
    return {
      drawer: true,
      rail: false,
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    isFormDetailView() {
      // Check if we're in any form detail route
      const formDetailRoutes = [
        'forms.overview',
        'forms.leads',
        'forms.detail.connectionstab.list',
        'forms.detail.connectionstab.create',
        'forms.detail.connectionstab.edit',
        'forms.settings',
        'forms.urlBuilder',
        'forms.trackingEvents',
        'forms.variants.create',
        'forms.variants.edit',
        'forms.experiments.overview',
        'forms.experiments.detail',
      ]
      return formDetailRoutes.includes(this.$route.name)
    }
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(isLoggedIn) {
        if (!isLoggedIn) {
          this.$router.replace({ name: 'login' })
        }
      }
    }
  }
}
</script>

<style scoped>
.main-content {
  background-color: var(--background) !important;
}

.main-content--fullwidth {
  padding-left: 0 !important;
}

/* Slim scrollbars with primary color theming */
:deep(.v-main),
:deep(.v-main__wrap),
:deep(.v-navigation-drawer),
:deep(.v-navigation-drawer__content) {
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--brand-color), 0.55) rgba(var(--brand-color), 0.08);
}

:deep(.v-main)::-webkit-scrollbar,
:deep(.v-main__wrap)::-webkit-scrollbar,
:deep(.v-navigation-drawer)::-webkit-scrollbar,
:deep(.v-navigation-drawer__content)::-webkit-scrollbar {
  width: 6px;
}

:deep(.v-main)::-webkit-scrollbar-track,
:deep(.v-main__wrap)::-webkit-scrollbar-track,
:deep(.v-navigation-drawer)::-webkit-scrollbar-track,
:deep(.v-navigation-drawer__content)::-webkit-scrollbar-track {
  background: rgba(var(--brand-color), 0.08);
}

:deep(.v-main)::-webkit-scrollbar-thumb,
:deep(.v-main__wrap)::-webkit-scrollbar-thumb,
:deep(.v-navigation-drawer)::-webkit-scrollbar-thumb,
:deep(.v-navigation-drawer__content)::-webkit-scrollbar-thumb {
  background-color: rgba(var(--brand-color), 0.55);
  border-radius: 999px;
}

:deep(.v-main)::-webkit-scrollbar-thumb:hover,
:deep(.v-main__wrap)::-webkit-scrollbar-thumb:hover,
:deep(.v-navigation-drawer)::-webkit-scrollbar-thumb:hover,
:deep(.v-navigation-drawer__content)::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--brand-color), 0.7);
}
</style>
